import React from 'react' 
import Bredcom from '../../Bredcom/Main' 
import Header from '../../headerone/Main' 
import First from './First' 
// import Brand from './Brand' 
 
function AlliedHealthSciences() { 
  return ( 
    <> 
        <Header/> 
        <Bredcom title="Home" subtitle="School of Allied Health Sciences" /> 
        <First/> 
        {/* <Brand/>  */}
    </> 
  ) 
} 
 
export default AlliedHealthSciences 